import { atom, useAtomValue } from 'jotai';
import { atomWithReset, useResetAtom } from 'jotai/utils';

export const isStartingAtom = atom<boolean>(true);
export const visibleChannelAtom = atomWithReset<string | undefined>(undefined);
export const needsAppUpdateAtom = atom<boolean>(false);
export const isLoggingOutAtom = atom<boolean>(false);
export const utmParamsAtom = atomWithReset<Record<string, string> | undefined>(undefined);
export const appStartedLoggedAtom = atomWithReset<boolean>(false);
/**
 * Set to true when an API call receives a 401 Unauthorized response.
 * A listener in use-logout-routine.ts will watch this atom and trigger the logout routine.
 */
export const api401DetectedAtom = atom<boolean>(false);

/**
 * When non-null, the login-as confirmation prompt is waiting for a user response.
 * The stored function is the promise resolver; call it with true/false to confirm/cancel.
 */
export const loginAsPromptAtom = atomWithReset<{
  resolve: (confirmed: boolean) => void;
  userName: string;
  currentUserPicture?: string;
  loginAsUserPicture?: string;
} | null>(null);

export function useResetAppAtoms() {
  const resetVisibleChannel = useResetAtom(visibleChannelAtom);
  const resetUtmParams = useResetAtom(utmParamsAtom);
  const resetAppStartedLogged = useResetAtom(appStartedLoggedAtom);
  const resetLoginAsPrompt = useResetAtom(loginAsPromptAtom);
  const loginAsPrompt = useAtomValue(loginAsPromptAtom);
  return () => {
    resetVisibleChannel();
    resetUtmParams();
    resetAppStartedLogged();
    loginAsPrompt?.resolve(false); // If a login-as prompt is active, cancel it
    resetLoginAsPrompt();
  };
}
